module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-BlackItalic.f960700.eot";